import List from '../../../../components/Operations/Engineering/DWG/List'
import PageTitle from '../../../../elements/PageTitle'
import { Breadcrumb, Card, Layout, Row } from 'antd'
import React, { Fragment } from 'react'

const { Content } = Layout

function DWG(props) {
  return (
    <Fragment>
      <Content style={{ margin: '0px 0px' }}>
        <Card>
          <Row>
            <Breadcrumb>
              <Breadcrumb.Item>Operations</Breadcrumb.Item>
              <Breadcrumb.Item>Engineering</Breadcrumb.Item>
              <Breadcrumb.Item href="#/operations/engineering/dwg/list">
                Technical Drawings
              </Breadcrumb.Item>
            </Breadcrumb>
            <PageTitle
              title={'Technical Drawings'}
              subtitle={'Register of Technical Drawings'}
              color={'#427035'}
              iconType={'file-unknown'}
            />
          </Row>
        </Card>
        <Row gutter={16} style={{ padding: 10 }}>
          <Card>
            <List {...props} />
          </Card>
        </Row>
      </Content>
    </Fragment>
  )
}

DWG.propTypes = {}
DWG.defaultProps = {}

export default DWG
